module.exports = __webpack_public_path__ + "static/install_exit_excel-2e2e805b5424f0ba6cf317b3217de488.png";